import { Component, Input, OnChanges } from '@angular/core';

import { BankBrand, resolveBankBrand } from '../../constants/bank-brands';

/**
 * Banka rozeti: logo varsa logo, yoksa marka renkli kısa kod.
 *
 * Listelerde banka adını yazıyla taşımak satırın yarısını yiyordu; logo aynı
 * bilgiyi tek bakışta veriyor. Ad **yazıyla tekrarlanmıyor**: üstüne gelince
 * tooltip'te, ekran okuyucuda ise `alt` olarak okunuyor.
 *
 * Marka sözlüğü mobil uygulamayla ortak (bkz. shared/constants/bank-brands.ts).
 */
@Component({
  selector: 'app-bank-logo',
  template: `
    <span class="d-inline-flex align-items-center" [ngbTooltip]="bankName || null" container="body">
      <img *ngIf="brand.logo" [src]="brand.logo" [alt]="bankName || 'Banka'"
           class="bank-logo rounded" [style.width.px]="size" [style.height.px]="size" />

      <span *ngIf="!brand.logo" class="bank-logo-badge rounded d-inline-flex align-items-center justify-content-center"
            [style.width.px]="size" [style.height.px]="size"
            [style.background-color]="brand.color"
            [style.font-size.px]="size * 0.36">
        {{ brand.short }}
      </span>
    </span>
  `,
  styles: [
    `
      .bank-logo {
        object-fit: contain;
        background: #fff;
        padding: 1px;
      }
      .bank-logo-badge {
        color: #fff;
        font-weight: 600;
        line-height: 1;
      }
    `,
  ],
})
export class BankLogoComponent implements OnChanges {
  @Input() bankName: string | null | undefined;
  @Input() size = 24;

  brand: BankBrand = resolveBankBrand(null);

  ngOnChanges(): void {
    this.brand = resolveBankBrand(this.bankName);
  }
}
